import { FilterTabs } from "@components/pageHeader/filters/lib";

export const INVOICE_PAGE_FILTER_TABS: FilterTabs[] = [
    FilterTabs.INVOICE_DATE,
    FilterTabs.INVOICE_STATUS_FILTER,
    FilterTabs.OVERDUE,
    FilterTabs.AMOUNT,
    FilterTabs.ACCOUNT,
    FilterTabs.CATALOG_ITEM,
    FilterTabs.INVOICE_SOURCE_TEMPLATE,
    FilterTabs.SUBSCRIPTION,
    FilterTabs.MATCH_STATUS,
    FilterTabs.COUNTERPARTY,
    FilterTabs.INVOICE_TERMS,
    FilterTabs.INVOICE_SENT_STATUS,
];
